/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Card, CardBody } from '../../../../components/card/card';
import { GetEquipmentsModelList } from '../../../../store/FLEET/EquipmentsModel/equipmentsmodelSlice';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { useTranslation } from 'react-i18next';
import ModalComponent from '../../../../components/Modal/ModalComponent';
import AddModel from './AddModel';
import NtxTable from '../../../../components/DataTable/NtxTable';
import Loading from '../../../../components/Shared/Loader/Loading';
import EditModel from './EditModel';
import { usePermissions } from '@Helper/Permisstions/usePermissions';

const Index = () => {
  const { HasPermission } = usePermissions();
  const [Show, setShow] = useState(false);
  const [id, setId] = useState('');

  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (EquipmentsModelList?.length === 0) {
      dispatch(GetEquipmentsModelList());
    }
  }, []);
  const { EquipmentsModelList, loading } = useAppSelector(state => state.EquipmentsModel);

  console.log(EquipmentsModelList);

  const columns = [
    { title: t('Model'), key: 'Model' },
    { title: t('Manufacturers'), key: 'Manufacturers' },
    { title: t('catagory'), key: 'catagory' },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData = EquipmentsModelList?.filter(f => f.parentId !== null)?.map(item => {
    let rowClass;

    return {
      Model: (
        <div className='d-flex align-items-center'>
          <div className='w-50px h-50px bg-white bg-opacity-25 d-flex align-items-center justify-content-center rounded-2'>
            {item.image === null ? (
              <img alt='' className='mw-100 mh-100' src='/assets/img/Image/noImage3.png' />
            ) : (
              <img alt='' className='mw-100 mh-100' src={item?.image?.filePath} />
            )}
          </div>
          <div className='ms-3'>{i18n.language === 'ar' ? item.name2 : item.name}</div>
        </div>
      ),
      catagory: item.catagory,
      Model2: i18n.language === 'ar' ? item.name2 : item.name,

      Manufacturers: (
        <div className='d-flex align-items-center'>
          <div className='w-50px h-50px bg-white bg-opacity-25 d-flex align-items-center justify-content-center  rounded-2'>
            {EquipmentsModelList?.find(f => f.id === item.parentId) === null ? (
              <img alt='' className='mw-100 mh-100' src='/assets/img/Image/noImage3.png' />
            ) : (
              // <img alt='' className='mw-100 mh-100' src={item?.image?.filePath} />
              <img
                alt=''
                className='mw-100 mh-100'
                src={EquipmentsModelList?.find(f => f.id === item.parentId)?.image?.filePath}
              />
            )}
          </div>
          <div className='ms-3'>
            {i18n.language === 'en'
              ? EquipmentsModelList?.find(f => f.id === item.parentId)?.name
              : EquipmentsModelList?.find(f => f.id === item.parentId)?.name2}
          </div>
        </div>
      ),

      action: (
        <>
          <button
            hidden={!HasPermission('FleetEditModel')}
            type='button'
            className='btn btn-outline-theme'
            // onClick={() => Navigate(`${item.id}/Edit`)}
            onClick={() => setId(item.id)}
            data-bs-toggle='modal'
            data-bs-target='#modalEditModel'
          >
            <i className='far fa-lg fa-fw me-2 fa-edit'></i>
            {t('Button.Edit')}
          </button>
        </>
      ),

      rowClass // استخدم rowClass هنا
    };
  });

  //____________________________

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
             link: ':moduleHome'
            },
            {
              name: 'Model',
              link: null
            }
          ]}
          PageName='Model'
        />
        <div className='ms-auto'>
          <a
            hidden={!HasPermission('FleetAddModel')}
            href=''
            className='btn me-1 btn-theme'
            data-bs-toggle='modal'
            data-bs-target='#modalِAddModel'
            onClick={() => setShow(true)}
          >
            <i className='fa fa-plus-circle fa-fw me-1'></i>
            {t('AddModel')}
          </a>
        </div>
      </div>

      <Card>
        <Loading loading={loading}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
              searchColumns={['catagory', 'Model2'] as any}
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={t('AddModel')} id='modalِAddModel'>
        {Show && <AddModel />}
      </ModalComponent>
      <ModalComponent title={t('EditModel')} id='modalEditModel'>
        {id && <EditModel id={id} />}
      </ModalComponent>
    </>
  );
};

export default Index;
